- x: "300"
  y: "0"
  size_x: "80"
  size_y: "80"
  obj_type: "enemy"
- x: "500"
  y: "0"
  size_x: "80"
  size_y: "80"
  obj_type: "obstacle"
- x: "500"
  y: "50"
  size_x: "80"
  size_y: "80"
  obj_type: "stone"
- x: "700"
  y: "0"
  size_x: "80"
  size_y: "80"
  obj_type: "enemy"
- x: "800"
  y: "0"
  size_x: "80"
  size_y: "80"
  obj_type: "obstacle"
- x: "1000"
  y: "0"
  size_x: "80"
  size_y: "80"
  obj_type: "coin"
- x: "1800"
  y: "0"
  size_x: "80"
  size_y: "80"
  obj_type: "enemy_boss"
- x: "2000"
  y: "0"
  size_x: "80"
  size_y: "80"
  obj_type: "goal"
